module.exports = __webpack_public_path__ + "static/media/gitlab.54b7b495.svg";